import { NextPage, NextPageContext } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'

import React from 'react'
import { content as contentSrc } from '@ucheba/dal/portal.web/vuz/rankings'
import {
  institutionsRankingsSelectors,
  institutionsRankingsThunks,
} from '@ucheba/store/institutions/rankings'
import { institutionsRankingsParticipantsThunks } from '@ucheba/store/institutions/rankings/detail/participants'
import { NextSeo } from 'next-seo'
import { Store } from 'redux'
import { IVuzRankingsPageProps } from './types'
import { headerActions } from '../../../../components/Header/store'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop')),
  touch: dynamic(() => import('./touch')),
}

const VuzRankingsPage: NextPage<IVuzRankingsPageProps> = (props) => {
  const { content = contentSrc } = props

  return (
    <>
      <NextSeo
        title={content.seo.meta.title}
        description={content.seo.meta.description}
        openGraph={{}}
      />

      {getIDeviceComponent({ ...props, content }, devicesPages)}
    </>
  )
}

VuzRankingsPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store } = ctx
  const { dispatch, getState } = store

  await dispatch<any>(institutionsRankingsThunks.fetch({ ctx }))

  const institutionsRankingsIds = institutionsRankingsSelectors.selectIds(getState())
  const requests: any[] = []

  institutionsRankingsIds.forEach((id) => {
    requests.push(
      dispatch<any>(
        institutionsRankingsParticipantsThunks.fetch({ ctx, data: { id: Number(id) } })
      )
    )
  })

  dispatch(headerActions.toggleHeader(true))

  await Promise.all(requests)

  return {}
}

export default VuzRankingsPage
